import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../core/services/_index';
import { Observable } from 'rxjs';
import { PersonneModel } from '../../core/modeles/personneModele';
import { AppConfigService } from '../../app-config.service';

@Injectable({
  providedIn: 'root'
})
export class PersonneApiService {
  constructor(
    private readonly _bffApiService: BffCommunicationService,
    private readonly _configService: AppConfigService
  ) {}

  /**
   * getUrl
   */
  private getUrl(): string {
    return `/api/v2/personnes`;
  }

  getPersonne(): Observable<PersonneModel> {
    return this._bffApiService.getJSONBFF(this.getUrl()) as Observable<PersonneModel>;
  }
}
